import { render, staticRenderFns } from "./BlockWarnInfo.vue?vue&type=template&id=60e66536&scoped=true&"
import script from "./BlockWarnInfo.vue?vue&type=script&lang=js&"
export * from "./BlockWarnInfo.vue?vue&type=script&lang=js&"
import style0 from "./BlockWarnInfo.vue?vue&type=style&index=0&id=60e66536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e66536",
  null
  
)

export default component.exports